import React from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { Hero } from './components/sections/Hero';
import { TrustStats } from './components/sections/TrustStats';
import { Transformation } from './components/sections/Transformation';
import { ForYou } from './components/sections/ForYou';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { InstantAccess } from './components/sections/InstantAccess';
import { BonusesDetail } from './components/sections/BonusesDetail';
import { Testimonials } from './components/sections/Testimonials';
import { AboutAuthor } from './components/sections/AboutAuthor';
import { Pricing } from './components/sections/Pricing';
import { KitUpsell } from './components/sections/KitUpsell';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { StickyCTA } from './components/ui/StickyCTA';
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3ii4r9zs8ioni">
      <div className="w-full min-h-full bg-bg-primary font-body text-white" data-id="element-1" data-mp="3mkrgdsxitvh0">
        <main data-id="element-2" data-mp="3rcj846sey78q">
          <Hero data-id="element-3" data-mp="3rbzomln47asl" />
          <TrustStats data-id="element-4" data-mp="3rdkie91luppe" />
          <Transformation data-id="element-5" data-mp="3rd189ei755lx" />
          <ForYou data-id="element-6" data-mp="5yhgo69t1c8" />
          <WhatYouGet data-id="element-7" data-mp="6htxpd5ixiv" />
          <InstantAccess data-id="element-8" data-mp="4n5i12o8na1" />
          <BonusesDetail data-id="element-9" data-mp="82ld64660ci" />
          <Testimonials data-id="element-10" data-mp="2zl3dbpgpde7f" />
          <AboutAuthor data-id="element-11" data-mp="2zlv8x0aavbxp" />
          <Pricing data-id="element-12" data-mp="2zmo3z3zwcd00" />
          <KitUpsell data-id="element-13" data-mp="2zn6biws0edn8" />
          <Guarantee data-id="element-14" data-mp="33morde4z3yj7" />
          <FAQ data-id="element-15" data-mp="33lwyib2rgewm" />
          <FinalCTA data-id="element-16" data-mp="33nges1of2pye" />
        </main>
        <Footer data-id="element-17" data-mp="33ork45xig5rm" />
        <StickyCTA data-id="element-18" data-mp="38lrpeemjd4ho" />
      </div>
    </LazyMotion>;
}